"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class PremiumTrialsNotFoundError extends client_library_1.ExtendableError {
    constructor() {
        super('Premium trials not found');
    }
}
exports.default = PremiumTrialsNotFoundError;
